export function whenOneTrustReady(cb) {
  var _window$OneTrustReady;
  window.OneTrustReadyHandlers = window.OneTrustReadyHandlers || [];
  // istanbul ignore next -- defensive: always truthy after the line above
  (_window$OneTrustReady = window.OneTrustReadyHandlers) === null || _window$OneTrustReady === void 0 || _window$OneTrustReady.push(cb);
}
//# sourceMappingURL=ready.js.map